module.exports = [
	{
		"value": "01",
		"label": "50+"
	},
	{
		"value": "02",
		"label": "150+"
	},
	{
		"value": "03",
		"label": "400+"
	},
	{
		"value": "04",
		"label": "1000+"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assess/question/attendance.json
// module id = 428
// module chunks = 0